import { FC, Fragment } from 'react';
import {
    PerformDateRangeFilterSelector,
    PerformMultiSelect,
} from '../perform-indicator/perform-indicator';
import { EquipmentFilterDto } from '@servicetitan/application-data/marketing';
import * as Styles from './segment-parts.module.less';

interface EquipmentProps {
    equipment: EquipmentFilterDto;
}

export const Equipment: FC<EquipmentProps> = ({ equipment }) => (
    <Fragment>
        <div className={Styles.segmentCardKpiName}>Equipment</div>
        <div>
            <PerformMultiSelect name="Name" value={equipment.names} />
            <PerformMultiSelect name="Location Zip Code" value={equipment.zipCodes} />
            <PerformMultiSelect name="Type" value={equipment.types} />
            <PerformMultiSelect name="Tags" value={equipment.tags} />
            <PerformMultiSelect name="Manufacturer" value={equipment.manufacturers} />
            <PerformMultiSelect name="Model" value={equipment.models} />
            <PerformDateRangeFilterSelector
                name="Installed Date"
                valueStatic={equipment.installDate}
                valueDynamic={equipment.installDateRelative}
            />
            <PerformDateRangeFilterSelector
                name="Manufacturer Warranty Start"
                valueStatic={equipment.manufacturerWarrantyStart}
                valueDynamic={equipment.manufacturerWarrantyStartRelative}
            />
            <PerformDateRangeFilterSelector
                name="Manufacturer Warranty End"
                valueStatic={equipment.manufacturerWarrantyEnd}
                valueDynamic={equipment.manufacturerWarrantyEndRelative}
            />
            <PerformDateRangeFilterSelector
                name="Service Provider Warranty Start"
                valueStatic={equipment.serviceWarrantyStart}
                valueDynamic={equipment.serviceWarrantyStartRelative}
            />
            <PerformDateRangeFilterSelector
                name="Service Provider Warranty End"
                valueStatic={equipment.serviceWarrantyEnd}
                valueDynamic={equipment.serviceWarrantyEndRelative}
            />
        </div>
    </Fragment>
);
